// Datadog RUM masks session replay text by default. Use this only when the
// product/security tradeoff has been considered and the unmasked content helps
// support/debugging. Prefer the narrowest element that contains the intended UI
// text, and keep credentials, secrets, profile/account details, and other
// user-private content masked.
export const DD_PRIVACY_ALLOW = 'allow';
